import React from 'react'
import { Outlet, Navigate } from 'react-router-dom';
import { Cookies } from './Shared/Cookies';

const ProtectedRoute: React.FC = () => {
    const CK = new Cookies();
    const useAuth = () => {
        let currentStatus = false;
        //CK.Load("isLogged") == "true" ? currentStatus = true : currentStatus = false;
        localStorage.getItem("isLogged") == "true" ? currentStatus = true : currentStatus = false;
        return currentStatus
    }
    const isAuth = useAuth();


    return isAuth ? <Outlet /> : <Navigate to="/" />;
}

export default ProtectedRoute;
